import { render, staticRenderFns } from "./customer-summary.vue?vue&type=template&id=72465529&scoped=true&"
import script from "./customer-summary.vue?vue&type=script&lang=js&"
export * from "./customer-summary.vue?vue&type=script&lang=js&"
import style0 from "./customer-summary.vue?vue&type=style&index=0&id=72465529&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72465529",
  null
  
)

export default component.exports